<template>

<section>
<v-toolbar flat dense color="blue-grey lighten-5" class="report_bar">
    <v-toolbar-title>
      Total: ${{totalSales}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          
          <v-btn
              icon
              color="accent-2"
              class="blue--text"
              v-if="isToday && ((currentDateSales && currentDateSales.length == 0) || !currentDateSales)"
              @click="openlogSales()"
            >
              <v-icon>mdi-clipboard-edit-outline</v-icon>
            </v-btn>

      <v-btn
              icon
              class="blue--text"
              v-else-if="currentDateSales"
              
              @click="editSalesReport(currentDateSales)"
            >
              <v-icon>mdi-clipboard-edit</v-icon>
            </v-btn>
          <allTransactionsByDate />
        </v-toolbar>

<v-row>

  <v-col cols="12" md="6">
<br />
    <p>Prepaid <span v-if="calculatedDailySales" class="float-right">$ {{calculatedDailySales.prepaidSales || 0 }}</span></p>
    <hr class="spacer" />

    <v-subheader>Credit Card</v-subheader>

    <v-data-table v-if="calculatedDailySales && dailySalesReport"
      class="no-footer-table"
                  :headers="ccHeaders" 
                  :items="ccItems"
                  >

 <template v-slot:item.ccSales="{item}">
       <span>$ {{item.ccSales || 0}} </span>
   </template>
   <template v-slot:item.ccTerminal="{item}">
       <span>$ {{item.ccTerminal || 0}} </span>
   </template>
   <template v-slot:item.ccDiscrepancy="{item}">
       <span>$ {{item.ccDiscrepancy || 0}} </span>
   </template>
              </v-data-table>

    <p v-if="currentDateSales" class="reason">{{currentDateSales.ccNotes}}</p>

  </v-col>

  <v-col cols="12" md="6">

    <v-subheader>Cash</v-subheader>

    <v-data-table v-if="calculatedDailySales && dailySalesReport"
      class="no-footer-table"
                  :headers="cashHeaders" 
                  :items="cashItems"
                  >    

  <template v-slot:item.cashSales="{item}">
       <span>$ {{item.cashSales || 0}} </span>
   </template>
   <template v-slot:item.Start="{item}">
    <span>$ {{item.Start || 0}} </span>
</template>
<template v-slot:item.total="{item}">
  <strong>$ {{item.total || 0}} </strong>
</template>

              </v-data-table>

    

    <v-data-table 
    class="no-footer-table"
                  :headers="onHandHeaders" 
                  :items="onHandItems"
                  hide-default-header
                  :mobile-breakpoint="0"
                  >
                 <template slot="body.append">
                      <tr class="blue--text">
                          <th>$1</th>
                          <th>$5</th>
                          <th>$10</th>
                          <th>$20</th>
                          <th>$50</th>
                          <th>$100</th>
                      </tr>
                  </template>
              </v-data-table>
    <v-data-table 
      class="no-footer-table"
      :headers="cashOutHeaders" 
      :items="cashOutItems"
        >
      <template v-slot:item.deposited="{item}">
       <span>$ {{item.deposited || 0}} </span>
      </template>
      <template v-slot:item.cashTomoStart="{item}">
          <span>$ {{item.cashTomoStart || 0}} </span>
      </template>
      <template v-slot:item.onHand="{item}">
        <strong>$ {{item.onHand || 0}} </strong>
        </template>
    </v-data-table>
    
    <ul class="cash">
      <li>Discrepancy <span>$ {{this.cashDiscrepancy || 0 }}</span></li>
      <li v-if="currentDateSales">{{currentDateSales.cashNotes}}</li>
  </ul>
  
  <ul class="cash" v-if="checkGate('users-mgmt')">
    <li>Safe <span v-if="safe">$ {{ safe.totalInSafe }}</span></li>
    <li>
      <span v-if="safe">
        Last time banked
        {{ new Date(this.safe.lastTimeBanked).toLocaleString("en-AU",  { timeZone : "UTC", weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}}
      </span>
      <v-btn
      @click="bankTotalInSafe(currentDateSales)"
  color="accent-2"
  class="blue--text"
  :disabled="((currentDateSales && currentDateSales.length == 0) || !currentDateSales)"
  >
  <v-icon>mdi-safe</v-icon> Bank
</v-btn>
    </li>
</ul>
  </v-col>
  
</v-row>         
	</section>
    
</template>

<script>    
    import allTransactionsByDate from '../components/allTransactionsByDate.vue'

    export default {

      components : { allTransactionsByDate },

       // props : ['dailysales'],
      
        data() {

            return {

              ccHeaders : [
                  { text : "Calculated", align: 'left', value: "ccSales", sortable: false },
                  { text : "CC Terminal", align: 'left', value: "ccTerminal", sortable: false },
                  { text : "Discrepancy", align: 'left', value: "ccDiscrepancy", sortable: false },
                  
              ],

              cashHeaders : [

                  { text : "Calculated", align: 'left', value: "cashSales", sortable: false },
                  { text : "Start", align: 'left', value: "Start", sortable: false },
                  { text : "Total Calculated", align: 'right', value: "total", sortable: false },
                  
              ],

              onHandHeaders : [

                { text : "$1", align: 'left', value: "ones", sortable: false },
                { text : "$5", align: 'left', value: "fives", sortable: false },
                { text : "$10", align: 'left', value: "tens", sortable: false },
                { text : "$20", align: 'left', value: "twenties", sortable: false },
                { text : "$50", align: 'left', value: "fifties", sortable: false },
                { text : "$100", align: 'left', value: "hundreds", sortable: false },

              ],

              cashOutHeaders : [
                { text : "Tomorrow Start", align: 'left', value: "cashTomoStart", sortable: false },
                  { text : "Deposited", align: 'left', value: "deposited", sortable: false },
                  { text : "Total on Hand", align: 'right', value: "onHand", sortable: false },
              ],

             
            }
        },


        computed: {


          isToday () {
            return this.$store.state.isToday
          },

          calculatedDailySales() {
                return this.$store.getters.calculatedDailySales
          },

          safe () {

                return this.$store.getters.safe
          },

          dailySalesReport() {
                return this.$store.getters.dailySalesReport
          },

          currentDateSales() {
              return this.dailySalesReport ? this.dailySalesReport.currentDate : null
          },

          prevDateSales() {
              return this.dailySalesReport ? this.dailySalesReport.prevDate : null
          },

          ccItems() {

            const ccSales = this.calculatedDailySales ? this.calculatedDailySales.ccSales : 0,

            ccTerminal = this.currentDateSales ? this.currentDateSales.ccTerminal : 0,
            ccDiscrepancy = this.currentDateSales ? this.currentDateSales.ccDiscrepancy : 0


            return [{ "ccSales": ccSales, "ccTerminal": ccTerminal, "ccDiscrepancy" : ccDiscrepancy} ]
          },

          onHand () {

               return this.currentDateSales ? (this.currentDateSales.ones * 1) + (this.currentDateSales.fives * 5) + (this.currentDateSales.tens *10) + (this.currentDateSales.twenties * 20) + (this.currentDateSales.fifties * 50) + (this.currentDateSales.hundreds * 100) : 0
          },

          cashItems() {
            
              const cashSales = this.calculatedDailySales ? parseFloat(this.calculatedDailySales.cashSales) : 0
              const  cashStart = this.prevDateSales ? parseFloat(this.prevDateSales.cashTomoStart) : 0
              const total = cashSales != 0 ? cashSales + cashStart : cashStart

            return [{
              "cashSales": cashSales, 
              "Start" : cashStart,
              "total": total
            }]

          },

          cashOutItems() {

            const deposited = this.currentDateSales ? this.currentDateSales.deposited : 0,
            cashTomoStart = this.currentDateSales ? this.currentDateSales.cashTomoStart : 0

            return [{
              "deposited" : deposited, 
              "cashTomoStart" : cashTomoStart,
              "onHand": this.onHand, 
             }]

          },

          cashDiscrepancy() {
            return this.currentDateSales ? this.currentDateSales.cashDiscrepancy : 0
          },

          onHandItems() {

            if (this.currentDateSales) {

              return [
                {
                  ones : this.currentDateSales.ones,
                  fives : this.currentDateSales.fives,
                  tens : this.currentDateSales.tens,
                  twenties : this.currentDateSales.twenties,
                  fifties : this.currentDateSales.fifties,
                  hundreds : this.currentDateSales.hundreds
                }
                ]
            } else {
            
                        return [
                        {
                          ones : 0,
                          fives : 0,
                          tens : 0,
                          twenties : 0,
                          fifties : 0,
                          hundreds : 0
                        }
                        ]

                }
          },

          totalSales () {
            if(this.calculatedDailySales) {

                const c = this.calculatedDailySales

                return parseFloat(c.cashSales) + parseFloat(c.ccSales) + parseFloat(c.prepaidSales) || 0

            }
            
          }

        },


        methods: {

          openlogSales() {
            this.$emit('logSales')
          },


          editSalesReport(currentDateItem) {

            this.$emit('editSalesReport',currentDateItem)

          },

          bankTotalInSafe(currentDateItem) {

            const currentDate = Object.assign({}, currentDateItem)
            currentDate.banked = this.safe.totalInSafe

            this.$emit('bankTotalInSafe',currentDate)
          }
  
        }
    }
</script>
